import request from '@/services/interceptor.js'

// ─── Utenti ──────────────────────────────────────────────────────────────────

export const get_utenti = () => {
    return request({
        url: '/admin/users',
        method: 'get',
        loadingBar: true
    })
}

export const crea_utente = (data) => {
    return request({
        url: '/admin/users',
        method: 'post',
        data,
        loadingBar: true
    })
}

export const modifica_utente = (id, data) => {
    return request({
        url: `/admin/users/${id}`,
        method: 'put',
        data,
        loadingBar: true
    })
}

export const elimina_utente = (id) => {
    return request({
        url: `/admin/users/${id}`,
        method: 'delete',
        loadingBar: true
    })
}

export const imposta_abilitazione = (id, enabled) => {
    return request({
        url: `/admin/users/${id}/enabled`,
        method: 'put',
        data: JSON.stringify(enabled),
        loadingBar: true,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export const invia_reset_password = (id) => {
    return request({
        url: `/admin/users/${id}/reset-password`,
        method: 'post',
        loadingBar: true
    })
}

// ─── Menu ─────────────────────────────────────────────────────────────────────

export const get_menu_utente = (id) => {
    return request({
        url: `/admin/users/${id}/menu`,
        method: 'get',
        loadingBar: true
    })
}

export const aggiorna_menu_utente = (id, menu) => {
    return request({
        url: `/admin/users/${id}/menu`,
        method: 'put',
        data: { menu },
        loadingBar: true
    })
}


export const richiedi_reset_password = (email) => {
    return request({
        url: '/auth/reset-password',
        method: 'post',
        data: { email },
        loadingBar: true
    })
}
